import React, { useEffect, useState } from 'react';
import Service from '../../services/news';
import ServiceGeneral from '../../services/general';
const createDOMPurify = require('dompurify');
const DOMPurify = createDOMPurify(window);
const NewsOverviewItem = ({ history, id }) => {
    const [news, setNews] = useState();

    useEffect(() => {
        Service.get(id).then(result => {
            setNews(result);
        });
    }, [id])

    const handleViewNieuws = (item) => {
        history.push('/home/' + item._id)
    }

    if (!news) return null;


    //  <div style={{ width: '100%' }}  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} ></div>
    return <div className='padding' >
        <h4>{ServiceGeneral.formatDate(news.date, false)}</h4>
        <h1>{news.title}</h1>
        {news.image && <div style={{ backgroundColor: 'white', backgroundImage: `url(${news.image})`, backgroundSize: 'cover', backgroundPosition: 'center center', width: '100%', height: '500px' }}>  </div>}

        <div style={{ width: '100%', paddingTop: '18px' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(news.content) }} ></div>

    </div>


};

export default NewsOverviewItem;